const getters = {
  contractVendors: state => state.contractVendors,
  openVendors: state => state.openVendors,
  isContractLoading: state => state.isContractLoading,
  all: state => state.all,
  openVehicles: state => state.openVehicles,
};

export default getters;
